import { ReactNode, createContext, useContext, useState } from "react";

type CaseDetailContextValue = {
  rightContent: ReactNode;
  setRightContent: (content: ReactNode) => void;
};

const CaseDetailContext = createContext<CaseDetailContextValue | undefined>(
  undefined
);

export const CaseDetailProvider = ({ children }: { children: ReactNode }) => {
  const [rightContent, setRightContent] = useState<ReactNode>(null);

  return (
    <CaseDetailContext.Provider
      value={{
        rightContent,
        setRightContent,
      }}
    >
      {children}
    </CaseDetailContext.Provider>
  );
};

export const useCaseDetail = () => {
  const context = useContext(CaseDetailContext);
  if (!context) {
    throw new Error("useCaseDetail must be used within CaseDetailProvider");
  }
  return context;
};
